export default class ProgramFields {

  static readonly firstName = "first_name"
  static readonly lastName = "last_name"
  static readonly position = "position"
  static readonly email = "email"
  static readonly phone = "phone"
  static readonly altPhone = "altPhone"
  static readonly description = "programDescription"
  static readonly mentorDescription = "mentorDescription"
  static readonly displayTitle = "title"
  static readonly nsTrainingDescription = "trainingDescription"

  static readonly administrators = "field_administrators"
  static readonly eMentoringServiceArea = "field_e_mentoring_service_area"
  static readonly facebook = "field_facebook"
  static readonly feedback = "field_feedback"
  static readonly focusArea = "field_focus_area"
  static readonly focusAreaOther = "field_focus_area_other"
  static readonly importId = "field_import_id"
  static readonly instagram = "field_instagram"
  static readonly logo = "field_logo"
  static readonly nsBackgroundCheck = "field_ns_background_check"
  static readonly nsBgCheck = "field_ns_bg_check"
  static readonly nsBgCheckTypes = "field_ns_bg_check_types"
  static readonly nsBgFingerprintType = "field_ns_bg_fingerprint_type"
  static readonly nsBgNameType = "field_ns_bg_name_type"
  static readonly nsBgOtherTypes = "field_ns_bg_other_types"
  static readonly nsPeerType = "field_ns_bg_peer_type"
  static readonly nsTraining = "field_ns_training"
  static readonly organizationEntity= "field_organization_entity"
  static readonly organizationFilter = "field_organization_filter"
  static readonly physicalLocations = "field_physical_locations"
  static readonly primaryMeetingLocation = "field_primary_meeting_location"
  static readonly primaryMeetingLocationOther = "field_primary_meeting_loc_other"
  static readonly accepting = "field_program_accepting"
  static readonly agesOther = "field_program_ages_other"
  static readonly agesServed = "field_program_ages_served"
  static readonly delivery = "field_program_delivery"
  static readonly matchesExplain = "field_program_matches_explain"
  static readonly familyServed = "field_program_family_served"
  static readonly familyOther = "field_program_family_other"
  static readonly gendersServed = "field_program_genders_served"
  static readonly gendersOther = "field_program_genders_other"
  static readonly gradesServed = "field_program_grades_served"
  static readonly beginningAndEnd = "field_program_beginning_and_end"
  static readonly hasSpecificGoals = "field_program_has_specific_goals"
  static readonly matchesHow = "field_program_matches_how"
  static readonly howAreMeetingsScheduled = "field_program_how_are_meetings_s"
  static readonly menteesWaitingList = "field_program_mentees_waiting_li"
  static readonly howOther = "field_program_how_other"
  static readonly mustTrainMentees = "field_program_must_train_mentees"
  static readonly ageMentorOther = "field_program_age_mentor_other"
  static readonly mentorFreqCommit = "field_program_mentor_freq_commit"
  static readonly mentorFreqOther = "field_program_mentor_freq_other"
  static readonly mentorHourCommit = "field_program_mentor_hour_commit"
  static readonly mentorHourOther = "field_program_mentor_hour_other"
  static readonly mentorMonthCommit = "field_program_mentor_month_commi"
  static readonly mentorMonthOther = "field_program_mentor_month_other"
  static readonly mustTrainMentors = "field_program_must_train_mentors"
  static readonly operatedThrough = "field_program_operated_through"
  static readonly operatedOther = "field_program_operated_other"
  static readonly ongoingSupport = "field_program_ongoing_support"
  static readonly screensMentees = "field_program_screens_mentees"
  static readonly screensMenteesHow = "field_program_screens_mentees_ho"
  static readonly screensMentors = "field_program_screens_mentors"
  static readonly screensMentorsHow = "field_program_screens_mentors_ho"
  static readonly whichGoals = "field_program_which_goals"
  static readonly whichGoalsOther = "field_program_which_goals_other"
  static readonly agesMentorTarget = "field_program_ages_mentor_target"
  static readonly genderMentorOther = "field_program_gender_mentor_oth"
  static readonly genderMentorTarget = "field_program_gender_mentor_targ"
  static readonly trainsMentees = "field_program_trains_mentees"
  static readonly trainsMenteesHow = "field_program_trains_mentees_how"
  static readonly trainsMentors = "field_program_trains_mentors"
  static readonly trainsMentorsHow = "field_program_trains_mentors_how"
  static readonly typesOfMentoringOther = "field_types_of_mentoring_other"
  static readonly youthPerYear = "field_program_youth_per_year"
  static readonly youthServed = "field_program_youth_served"
  static readonly youthOther = "field_program_youth_other"
  static readonly standing = "field_standing"
  static readonly twitter = "field_twitter"
  static readonly typesOfMentoring = "field_types_of_mentoring"
  static readonly website = "field_website"

}
